import Vue from 'vue'
import Router from 'vue-router'
import { can } from '@/_helpers/rbac.js'

import DashboardLayout from '../views/DashboardLayout'
import Login from '../views/Login.vue'
import VerifyCode from '../views/VerifyCode.vue'
import Home from '../views/Home.vue'
import ShowMore from '../views/ShowMore.vue'
import BalanceHistory from '../views/BalanceHistory.vue'
// import UserProfile from '../views/UserProfile.vue'
Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login',
      name: 'login',
      component: Login
    },
    { path: '/verify',
      name: 'verify',
      component: VerifyCode
    },
    { path: '/more',
      name: 'more',
      component: DashboardLayout,
      children: [
        { path: '', component: ShowMore }
      ],
      meta: {
        authorize: () => can('shared.test', 'users')
      }
    },
    { path: '/balance',
      name: 'balance',
      component: DashboardLayout,
      children: [
        { path: '', component: BalanceHistory }
      ]
    },
    /* { path: '/profile',
      name: 'profile',
      component: DashboardLayout,
      children: [
        { path: '', component: UserProfile }
      ]
    }, */
    { path: '/',
      name: 'home',
      component: DashboardLayout,
      children: [
        { path: '', component: Home }
      ]
    },

    // otherwise redirect to home
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  var authorize
  const auth = record => {
    var res = record.meta.authorize
    if (res) {
      authorize = res
    }
    return res
  }
  if (to.matched.some(auth)) {
    if (authorize()) {
      next()
    } else {
      // next('/login')
    }
  } else {
    next()
  }
})



// WEBPACK FOOTER //
// ./src/_helpers/router.js